import { Amount } from './amount.model';

export enum ACCOUNT_TEMPLATE_TYPES {
  SMART_CASH = 'smart_cash',
  TRADING = 'trading',
  WEALTH = 'wealth',
  TRADING_USA = 'trading_usa',
}

export enum ACCOUNT_STATUS_TYPES {
  ACTIVE_NOT_FUNDED = 'active_not_funded',
  ACTIVE = 'active',
  PENDING = 'pending',
}

export interface IAccountResponse {
  account_id: string;
  legacy_contract_id: string;
  name: string;
  number: number;
  management_type_template: ACCOUNT_TEMPLATE_TYPES;
  position: Amount;
  plus_minus: Amount;
  plus_minus_percentage: number;
  status: ACCOUNT_STATUS_TYPES;
  collecting_account: string;
  profile_type: string;
  created_at: string;
  available_amount: Amount;
  available_transfer_amount: Amount;
  cash_today: Amount;
  cash24_hrs: Amount;
  cash48_hrs: Amount;
}

export interface IAccount {
  accountId: string;
  legacyContractId: string;
  name: string;
  accountNumber: number;
  managementTypeTemplate: ACCOUNT_TEMPLATE_TYPES;
  position: Amount;
  plusMinus: Amount;
  plusMinusPercentage: number;
  status: ACCOUNT_STATUS_TYPES;
  collectingAccount: string;
  profileType: string;
  createdAt: string;
  contractId?: string;
}

export class AccountViewModel implements IAccount {
  static fromJSON(json: IAccountResponse): AccountViewModel {
    return new AccountViewModel(
      json.account_id,
      json.legacy_contract_id,
      json.name,
      json.number,
      json.management_type_template,
      json.position,
      json.plus_minus,
      json.plus_minus_percentage,
      json.status,
      json.collecting_account,
      json.profile_type,
      json.created_at,
    );
  }

  constructor(
    public accountId: string,
    public legacyContractId: string,
    public name: string,
    public accountNumber: number,
    public managementTypeTemplate: ACCOUNT_TEMPLATE_TYPES,
    public position: Amount,
    public plusMinus: Amount,
    public plusMinusPercentage: number,
    public status: ACCOUNT_STATUS_TYPES,
    public collectingAccount: string,
    public profileType: string,
    public createdAt: string,
    public contractId?: string,
  ) {}
}
